import React from 'react'
import { SwitchTransition, Transition } from 'react-transition-group'
import { gsap } from 'gsap'

import useResponsive from '../hooks/useResponsive'

export default (props) => {

  const { isFullhd, isMobileText, isMobileAccordion } = useResponsive()

  // Everything is based on props.currentPlace property
  //   thus avoiding making a sub-state management nightmare
  const countCurrentCareerPlaces = () =>
    props.currentPlace.stack?.reduce((prev, cur) => prev + cur.length);
  const revealEls = '.placeCard__title, .placeCard__text, .placeCard__lists > li'

  const onEnter = node => {
    gsap
      .fromTo(document.querySelectorAll(revealEls),
        { autoAlpha: 0 },
        { autoAlpha: 1,
          stagger: .2, })
}

  const onExit = node => {
    gsap.killTweensOf(revealEls)
    gsap
      .to(node.querySelectorAll(revealEls),
        { autoAlpha: 0,
          duration: .3, })
  }

  return (
    <SwitchTransition>
      <Transition
        key={props.currentPlace.key}
        onEnter={onEnter}
        onExit={onExit}
        timeout={{ // Enter timeout is how many li items + title + text * stagger value
          enter: ((countCurrentCareerPlaces() ?? 0) + 2) * 200,
          exit: 500,
         }}>
        <div className={ "placeCard tile is-vertical " + (isFullhd ? "is-7" : "is-8") }>
          <div className="placeCard__top tile is-parent is-vertical">
            <h4 className={ "placeCard__title title is-child "
            + (isMobileAccordion
              ? "is-5"
              : (isFullhd || isMobileText
                ? "is-3"
                : "is-4")
            )}>
              {props.currentPlace.jobTitle}
            </h4>
            <p
              className={"placeCard__text tile is-child content "
              + (isMobileText ? "is-medium" : "")}
              dangerouslySetInnerHTML={{__html:props.currentPlace.desc}}></p>
          </div>
          { props.currentPlace.stack &&
            <div className="tile placeCard__bottom">
              { // Map data into multiple lists
                props.currentPlace.stack?.map((innerElList, i, stack) =>
                  <ul
                    key={i}
                    className={"placeCard__lists tile is-vertical is-parent " + (stack.length === 2 ? "is-5" : "is-4")}>
                    {innerElList.map(innerEl =>
                      <li key={innerEl}>{innerEl}</li>
                    )}
                  </ul>
                )
              }
            </div>
          }
        </div>
      </Transition>
    </SwitchTransition>
  )
}
